import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useContext, useEffect, useState } from "react";
import Portal from "@mui/material/Portal";
import { useIsInsideContainer } from "../hooks/index.js";
import { PortalContext } from "./PortalContext.js";
const Portal_Portal = (t0)=>{
    const $ = c(11);
    const { children } = t0;
    const isInsideContainer = useIsInsideContainer();
    const portalContext = useContext(PortalContext);
    const [container, setContainer] = useState(null);
    let t1;
    if ($[0] !== isInsideContainer || $[1] !== (null == portalContext ? void 0 : portalContext.portalId) || $[2] !== (null == portalContext ? void 0 : portalContext.widgetContainerId)) {
        t1 = ()=>{
            if (!isInsideContainer) return;
            const portalId = null == portalContext ? void 0 : portalContext.portalId;
            const widgetContainerId = null == portalContext ? void 0 : portalContext.widgetContainerId;
            if (!portalId || !widgetContainerId) return;
            const shadowRootWrapper = document.getElementById(widgetContainerId);
            const root = null == shadowRootWrapper ? void 0 : shadowRootWrapper.shadowRoot;
            const portal = null == root ? void 0 : root.getElementById(`portal-container-${portalId}`);
            if (portal) setContainer(portal);
        };
        $[0] = isInsideContainer;
        $[1] = null == portalContext ? void 0 : portalContext.portalId;
        $[2] = null == portalContext ? void 0 : portalContext.widgetContainerId;
        $[3] = t1;
    } else t1 = $[3];
    const t2 = null == portalContext ? void 0 : portalContext.portalId;
    const t3 = null == portalContext ? void 0 : portalContext.widgetContainerId;
    let t4;
    if ($[4] !== isInsideContainer || $[5] !== t2 || $[6] !== t3) {
        t4 = [
            isInsideContainer,
            t2,
            t3
        ];
        $[4] = isInsideContainer;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    useEffect(t1, t4);
    const t5 = isInsideContainer ? container : void 0;
    let t6;
    if ($[8] !== children || $[9] !== t5) {
        t6 = /*#__PURE__*/ jsx(Portal, {
            container: t5,
            children: children
        });
        $[8] = children;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
};
export { Portal_Portal as Portal };
